import styled from "styled-components"
import { StatusContainer } from "./Shared.styled"

export const StyledStatusContainer = styled(StatusContainer)`
  display: flex;
  justify-content: flex-end;
`

export const Info = styled.p`
  font-size: 1.2rem;
  margin: 0;
`

export const StockInfo = styled(Info)`

`

export const Incoming = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  border: 0.1rem solid ${({ theme }) => theme.colors.grey};
border-radius: 0.6rem;
  padding: 0.3rem 0.8rem;
  width: fit-content;
  margin-top: 0.5rem;
  &:hover {
    background-color: ${({ theme }) => theme.colors.white};
  }

  svg {
    height: 1rem;
    margin-right: 0.5rem;
  }
`

export const StockButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  background: transparent;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.4rem;
  cursor: pointer;
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.greyDark};
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    border-color: ${(p) => p.theme.colors.turquoiseDark};
    color: ${(p) => p.theme.colors.turquoiseDark};

    svg {
      fill: ${(p) => p.theme.colors.turquoiseDark};
    }
  }

  svg {
    width: 1.4rem;
    height: 1.4rem;
  }
`
